import * as React from 'react'
import AddBusinessIcon from '@mui/icons-material/AddBusiness'
// ICONS
import CancelIcon from '@mui/icons-material/Cancel'
import CloudSyncIcon from '@mui/icons-material/CloudSync'
// TO DO: remove when not needed
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown'
import PersonRemoveIcon from '@mui/icons-material/PersonRemove'
import SimCardIcon from '@mui/icons-material/SimCard'
// MUI components
import { Box, Divider } from '@mui/material'
import Button from '@mui/material/Button'
import Fade from '@mui/material/Fade'
import Menu from '@mui/material/Menu'
import { MenuProps } from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import { alpha, styled } from '@mui/material/styles'
import { useUnleashClient } from '@unleash/proxy-client-react'
import FaberFeatureToggle from 'common/FaberComponents/FaberFeatureToggle'

export const StyledMenu = styled((props: MenuProps) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right'
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right'
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[300],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0'
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5)
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        )
      }
    }
  }
}))

export default function ActionMenuForOneUser({
  productType,
  handleEsimRequestDialogV2Open,
  handleSuspendOrUnsuspendDialogOpen,
  handleWinbackDialogOpen,
  handleCancelSubDialogOpen,
  handleRefreshNetworkDialogOpen,
  showRefreshNetworkButton
}: ActionProps) {
  const unleash = useUnleashClient()
  const isEsimRequestOTPEnabled = unleash.isEnabled('replace-esim-otp')

  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget)
  }
  const handleClose = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <Box>
        <Button
          variant='contained'
          id='fade-button'
          aria-controls={open ? 'fade-menu' : undefined}
          aria-haspopup='true'
          aria-expanded={open ? 'true' : undefined}
          onClick={handleClick}
          sx={{ fontSize: '12px', padding: '4px 12px' }}
          endIcon={<KeyboardArrowDownIcon />}
        >
          Actions
        </Button>
        <StyledMenu
          id='fade-menu'
          MenuListProps={{
            'aria-labelledby': 'fade-button'
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
          TransitionComponent={Fade}
        >
          {showRefreshNetworkButton && (
            <FaberFeatureToggle
              activeComponent={
                <MenuItem
                  sx={{ fontSize: '12px' }}
                  onClick={handleRefreshNetworkDialogOpen}
                >
                  <CloudSyncIcon />
                  Refresh network
                </MenuItem>
              }
              inactiveComponent={<></>}
              feature='refresh-network'
            />
          )}
          {productType !== 'otp' ||
          (productType === 'otp' && isEsimRequestOTPEnabled) ? (
            <MenuItem
              onClick={() => handleEsimRequestDialogV2Open()}
              sx={{ fontSize: '12px' }}
            >
              <SimCardIcon />
              eSIM replacement /
              <br />
              Resend eSIM activation email
            </MenuItem>
          ) : null}
          <Divider sx={{ width: '100%' }} />
          {productType === 'otp' ? (
            <></>
          ) : (
            <MenuItem
              onClick={() => handleWinbackDialogOpen()}
              sx={{ fontSize: '12px' }}
            >
              <AddBusinessIcon />
              Customer winback
            </MenuItem>
          )}
          {productType === 'otp' ? (
            <></>
          ) : (
            <>
              <MenuItem
                sx={{ fontSize: '12px' }}
                onClick={handleSuspendOrUnsuspendDialogOpen}
              >
                <PersonRemoveIcon />
                Suspend/Unsuspend User
              </MenuItem>

              <MenuItem
                sx={{ fontSize: '12px' }}
                onClick={handleCancelSubDialogOpen}
              >
                <CancelIcon />
                Cancel Subscription Now
              </MenuItem>
            </>
          )}
        </StyledMenu>
      </Box>
    </>
  )
}

interface ActionProps {
  handleEsimRequestDialogOpen: (event: string) => void
  handleEsimRequestDialogV2Open: () => void
  handleSuspendOrUnsuspendDialogOpen: () => void
  handleWinbackDialogOpen: () => void
  handleCancelSubDialogOpen: () => void
  handleRefreshNetworkDialogOpen: () => void
  showRefreshNetworkButton: boolean
  productType?: string
}
